import script from "./HelpCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpCenter.vue?vue&type=script&setup=true&lang=js"

import "./HelpCenter.vue?vue&type=style&index=0&id=4fc17a77&scoped=true&lang=less"

import exportComponent from "E:\\code\\软著项目\\software\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc17a77"]])

export default __exports__